import { inject, Pipe, PipeTransform } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { FileManagementService } from '../file-management.service';

@Pipe({
  name: 'fileUrl',
  standalone: true,
})
export class FileUrlPipe implements PipeTransform {
  fileManagementService = inject(FileManagementService);

  transform(value: any): Observable<string> {
    if (value == null || value.file == null) return of(null);

    if (value.file.content != null) {
      return of(value.file.content);
    } else {
      return from(this.fileManagementService.blobUrl(value.file));
    }
  }
}
